import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import RecoveryPasswordRepository from '../repositories/RecoveryPasswordRepository';

export default function useRecoveryPassword() {
  const auth = getAuth();
	const navigate = useNavigate();
	const { enqueueSnackbar } = useSnackbar();
	const [email, setEmail] = useState('');
	const [error, setError] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const isValidEmail = (email: string) => {
		return /\S+@\S+\.\S+/.test(email);
	}

	const enviaEmail = async () => {
    try {
      setIsSubmitting(true);
      if (isValidEmail(email)) {
        const recoveryPasswordRepository = new RecoveryPasswordRepository();
        const user = await recoveryPasswordRepository.findUser(email);
        if (user) {
          await sendPasswordResetEmail(auth, email);
          enqueueSnackbar(`Enviamos um link de recuperação de senha para o endereço de email ${email}!`);
          navigate(-1);
        } else {
          enqueueSnackbar('O email inserido não consta no sistema.', { variant: 'error' });
        }
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
      enqueueSnackbar(error, { variant: 'error' });
    } finally {
      setIsSubmitting(false)
    }
	}

  const onChange = (e: any) => {
    setEmail(e.target.value)
    setError(false)
  }
  
  return {
    email,
    onChange, 
    error, 
    enviaEmail, 
    isSubmitting
  }
}
